var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 158 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_2501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 158,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.5,
    height: 140,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_2501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.874 108.751V110.251H129.57V109.992H129.374V108.751H130.874ZM1.9742 108.751H0.474199V110.251H1.7782V109.992H1.9742V108.751ZM0.474199 127.101V128.601H1.9742V127.361H1.7782V127.101H0.474199ZM129.374 128.601H130.874V127.101H129.57V127.361H129.374V128.601ZM130.874 112.473H129.374V114.954H130.874V112.473ZM130.874 117.436H129.374V119.917H130.874V117.436ZM130.874 122.398H129.374V124.879H130.874V122.398ZM126.962 128.601V127.101H124.354V128.601H126.962ZM121.746 128.601V127.101H119.138V128.601H121.746ZM116.53 128.601V127.101H113.922V128.601H116.53ZM111.314 128.601V127.101H108.706V128.601H111.314ZM106.098 128.601V127.101H103.49V128.601H106.098ZM100.882 128.601V127.101H98.2743V128.601H100.882ZM95.6663 128.601V127.101H93.0583V128.601H95.6663ZM90.4503 128.601V127.101H87.8423V128.601H90.4503ZM85.2343 128.601V127.101H82.6263V128.601H85.2343ZM80.0183 128.601V127.101H77.4102V128.601H80.0183ZM74.8022 128.601V127.101H72.1942V128.601H74.8022ZM69.5862 128.601V127.101H66.9782V128.601H69.5862ZM64.3702 128.601V127.101H61.7622V128.601H64.3702ZM59.1542 128.601V127.101H56.5462V128.601H59.1542ZM53.9382 128.601V127.101H51.3302V128.601H53.9382ZM48.7222 128.601V127.101H46.1142V128.601H48.7222ZM43.5062 128.601V127.101H40.8982V128.601H43.5062ZM38.2902 128.601V127.101H35.6822V128.601H38.2902ZM33.0742 128.601V127.101H30.4662V128.601H33.0742ZM27.8582 128.601V127.101H25.2502V128.601H27.8582ZM22.6422 128.601V127.101H20.0342V128.601H22.6422ZM17.4262 128.601V127.101H14.8182V128.601H17.4262ZM12.2102 128.601V127.101H9.60221V128.601H12.2102ZM6.9942 128.601V127.101H4.3862V128.601H6.9942ZM0.474199 124.879H1.9742V122.398H0.474199V124.879ZM0.474199 119.917H1.9742V117.436H0.474199V119.917ZM0.474199 114.954H1.9742V112.473H0.474199V114.954ZM4.3862 108.751V110.251H6.9942V108.751H4.3862ZM9.6022 108.751V110.251H12.2102V108.751H9.6022ZM14.8182 108.751V110.251H17.4262V108.751H14.8182ZM20.0342 108.751V110.251H22.6422V108.751H20.0342ZM25.2502 108.751V110.251H27.8582V108.751H25.2502ZM30.4662 108.751V110.251H33.0742V108.751H30.4662ZM35.6822 108.751V110.251H38.2902V108.751H35.6822ZM40.8982 108.751V110.251H43.5062V108.751H40.8982ZM46.1142 108.751V110.251H48.7222V108.751H46.1142ZM51.3302 108.751V110.251H53.9382V108.751H51.3302ZM56.5462 108.751V110.251H59.1542V108.751H56.5462ZM61.7622 108.751V110.251H64.3702V108.751H61.7622ZM66.9782 108.751V110.251H69.5862V108.751H66.9782ZM72.1942 108.751V110.251H74.8022V108.751H72.1942ZM77.4102 108.751V110.251H80.0183V108.751H77.4102ZM82.6263 108.751V110.251H85.2343V108.751H82.6263ZM87.8423 108.751V110.251H90.4503V108.751H87.8423ZM93.0583 108.751V110.251H95.6663V108.751H93.0583ZM98.2743 108.751V110.251H100.882V108.751H98.2743ZM103.49 108.751V110.251H106.098V108.751H103.49ZM108.706 108.751V110.251H111.314V108.751H108.706ZM113.922 108.751V110.251H116.53V108.751H113.922ZM119.138 108.751V110.251H121.746V108.751H119.138ZM124.354 108.751V110.251H126.962V108.751H124.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138,
    cy: 100.759,
    rx: 24,
    ry: 10.7586,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.172,
    cy: 109.035,
    rx: 19.8621,
    ry: 6.62069,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.31,
    y: 99.1035,
    width: 39.7241,
    height: 9.93103,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.31,
    y: 99.1035,
    width: 39.7241,
    height: 9.93103,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.31,
    y: 99.1035,
    width: 39.7241,
    height: 9.93103,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.31,
    y: 99.1035,
    width: 39.7241,
    height: 9.93103,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.172,
    cy: 99.1031,
    rx: 19.8621,
    ry: 6.62069,
    fill: "#304FF2",
    stroke: "white",
    strokeWidth: 1.52586
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.31 122.277V132.208C117.31 135.865 126.203 138.829 137.172 138.829C148.142 138.829 157.034 135.865 157.034 132.208V122.277C157.033 125.934 148.141 128.897 137.172 128.897C126.203 128.897 117.311 125.934 117.31 122.277Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.31 110.69V120.621C117.31 124.278 126.203 127.242 137.172 127.242C148.142 127.242 157.034 124.278 157.034 120.621V110.69C157.034 114.347 148.141 117.311 137.172 117.311C126.203 117.311 117.311 114.347 117.31 110.69Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.31 110.69V120.621C117.31 124.278 126.203 127.242 137.172 127.242C148.142 127.242 157.034 124.278 157.034 120.621V110.69C157.034 114.347 148.141 117.311 137.172 117.311C126.203 117.311 117.311 114.347 117.31 110.69Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.31 110.69V120.621C117.31 124.278 126.203 127.242 137.172 127.242C148.142 127.242 157.034 124.278 157.034 120.621V110.69C157.034 114.347 148.141 117.311 137.172 117.311C126.203 117.311 117.311 114.347 117.31 110.69Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.31 110.69V120.621C117.31 124.278 126.203 127.242 137.172 127.242C148.142 127.242 157.034 124.278 157.034 120.621V110.69C157.034 114.347 148.141 117.311 137.172 117.311C126.203 117.311 117.311 114.347 117.31 110.69Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6249 56.75H42.1249V137.5H22.6249V56.75ZM56.7499 56.75H76.2499V137.5H56.7499V56.75ZM90.8749 56.75H110.375V137.5H90.8749V56.75Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55954 39.2749V51.6814H124.789V39.2749L65.6742 15.2891L6.55954 39.2749Z",
    fill: "#FAFAFA",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.625,
    cy: 34.625,
    r: 9.625,
    stroke: "black",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchanges);
export default __webpack_public_path__ + "static/media/exchanges.bf969f6b31458ebb31d79a78d87cd962.svg";
export { ForwardRef as ReactComponent };